module.exports = __webpack_public_path__ + "img/C12.ad3d5fcb.png";